var exports = {
  "a": "Box__7dvoNR",
  "w": "Box_1__EF6o9P",
};

module.exports = exports;
